import { Product_Group_Key, Unit_Of_Measure } from '@occc/graphql';

import { titleByPeriod } from './constants';

import { ProductGroupAlertSeverity, WalletFormValues } from '../types';

type MessageByCountWalletBy = Record<Unit_Of_Measure, (periodTitle: string) => string>;

const createQuantityMessage =
  (item: string) =>
  (period: string): string =>
    `How many ${item} do you normally buy per ${period}?`;

const createAmountMessage =
  (item: string) =>
  (period: string): string =>
    `How much do you usually spend on ${item} per ${period}?`;

const gallonsOfFuelMessage = createQuantityMessage('gallons of fuel');

const fuelGradeMessageByCountWalletBy: MessageByCountWalletBy = {
  [Unit_Of_Measure.Unit]: gallonsOfFuelMessage,
  [Unit_Of_Measure.Gallon]: gallonsOfFuelMessage,
  [Unit_Of_Measure.Amount]: createAmountMessage('fuel'),
};

const nonFuelGradeMessageByCountWalletBy: MessageByCountWalletBy = {
  [Unit_Of_Measure.Unit]: createQuantityMessage('candy bars'),
  [Unit_Of_Measure.Gallon]: gallonsOfFuelMessage,
  [Unit_Of_Measure.Amount]: createAmountMessage('coffee'),
};

export const getSurveySuggestion = (values: Partial<WalletFormValues>): string | null => {
  const { productGroup, period, countWalletBy } = values;

  if (!productGroup || !period || !countWalletBy) {
    return null;
  }

  const periodMessage = titleByPeriod[period];
  const messageByCountWalletBy =
    productGroup.key === Product_Group_Key.FuelGradeId
      ? fuelGradeMessageByCountWalletBy
      : nonFuelGradeMessageByCountWalletBy;

  return messageByCountWalletBy[countWalletBy]?.(periodMessage) ?? null;
};

export const getProductGroupAlertSeverity = (
  productCount: number,
): ProductGroupAlertSeverity | null => {
  if (productCount >= 5) {
    return 'error';
  } else if (productCount >= 3) {
    return 'warning';
  } else if (productCount >= 1) {
    return 'success';
  }

  return null;
};
